import { render, staticRenderFns } from "./YearFilter.vue?vue&type=template&id=3d645fda&"
import script from "./YearFilter.vue?vue&type=script&lang=js&"
export * from "./YearFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports